import React from 'react';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import { useToggle } from '../../hooks';

interface PoliciesCollapseProps {
    title: string;
    children?: React.ReactNode;
}

export const PoliciesCollapse: React.FC<PoliciesCollapseProps> = React.memo(
    ({ title, children }) => {
        const [open, toggleOpen] = useToggle(false);
        return (
            <>
                <li>
                    <ListItem
                        onClick={toggleOpen}
                        sx={{
                            background: '#6e1a1e',
                            color: '#fff',
                            cursor: 'pointer'
                        }}
                    >
                        <ListItemText
                            primary={
                                <Typography
                                    style={{
                                        fontWeight: 600,
                                        fontSize: open ? '1.1rem' : '1rem',
                                        padding: open ? '0.5rem 0' : 0
                                    }}
                                >
                                    {title}
                                </Typography>
                            }
                        />
                        {open != null ? (
                            open ? (
                                <FolderOpenIcon />
                            ) : (
                                <FolderIcon />
                            )
                        ) : null}
                    </ListItem>
                    <Divider />
                </li>
                <Collapse component='li' in={open} timeout='auto' unmountOnExit>
                    <List disablePadding>{children}</List>
                </Collapse>
            </>
        );
    }
);
